import { render, staticRenderFns } from "./MoleculeFeedAssetsContentModalDuplicate.vue?vue&type=template&id=36bbc418&"
import script from "./MoleculeFeedAssetsContentModalDuplicate.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedAssetsContentModalDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports